import React, { Component } from 'react';
import '../App.css';
import { Layout } from 'antd';
import FooterComponent from './footer';
import HeaderComponent from './header';
const { Content } = Layout;

class AlreadyCompletedPage extends Component {

    render() {
        return (
            <Layout style={{ height: "100%" }}>
                <HeaderComponent />
                <Content>
                    <div className="Survey-Holder" style={{ height: "80%" }} >
                        <h3 className="App-header">You have already taken this survey</h3>
                    </div></Content>
                <FooterComponent />
            </Layout>
        );
    }
}

export default AlreadyCompletedPage;